module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/kpi/indicator.component.sass
// module id = ./src/app/modules/kpi/indicator.component.sass
// module chunks = main